import { useSelector } from "react-redux";
import { Navigate } from "react-router";
import { EXTERNAL_LOGIN_URL } from "../../../../consts";
import { getLoggedIn } from "../../../../store/selectors";

const RedirectLogin = () =>
  (!useSelector(getLoggedIn) && <Navigate to={EXTERNAL_LOGIN_URL} />) || null;

export default RedirectLogin;
